import { BaseModel, ModelInstance, ToFrontHook, ToBackHook, listField, enumField } from './util';

export enum RugbyFoulSanctions {
  scrum = 1,
  lineout,
  free_kick,
  penalty_shot,
  yellow_card,
  red_card,
  start_kick,
  twenty_two_meters_kick,
  conversion_cancel
}

export enum RugbyFoulGameStage {
  start_kick= 1,
  open_game,
  tackle,
  ruck_or_maul,
  scrum,
  out_and_lineout,
  scoring_field,
  kick_on_goal,
  free_kick,
  team,
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    sanction: 'sanction',
    game_stage: 'gameStage',
  },
  relation: {
    sanction: listField(enumField(RugbyFoulSanctions)),
    gameStage: enumField(RugbyFoulGameStage),
  }
})
export class RugbyFoulType extends BaseModel {
  id: number;
  name: string;
  sanction: RugbyFoulSanctions[];
  gameStage: RugbyFoulGameStage;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
